import { render } from "./Notice.vue?vue&type=template&id=77e63fa7"
const script = {}

import "./Notice.vue?vue&type=style&index=0&id=77e63fa7&lang=scss"

import exportComponent from "/var/www/patternmaking/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__